<script>
  import {Link} from "@inertiajs/vue3";

  export default {
    components: {Link},
    emits: ['backToOverview'],
    props: {
      cancelRoute: {
        type: String,
        required: false
      },
      formId: {
        type: String,
        required: true
      },
      loading: {
        type: Boolean,
        default: false
      }
    }
  }
</script>

<template>
  <div class="d-flex gap-2">
    <Link v-if="cancelRoute" :href="cancelRoute" class="btn btn-secondary">Annuleren</Link>

    <button :form="formId" :class="{'btn btn-responsive btn-primary': true, 'loading' : loading}" :disabled="loading">
      <i class="bi bi-floppy"></i>
      <span>Opslaan</span>
    </button>

    <button @click="$emit('backToOverview')" :form="formId" :class="{'btn btn-primary': true, 'loading' : loading}" :disabled="loading">
      Opslaan en sluiten
    </button>
  </div>
</template>